export default function () {
  if (typeof gon.fund_goal != "undefined") {
    var fundraiserGoal = gon.fund_goal;
    var fundraiserRaised = gon.fund_raised;
  } else {
    var fundraiserGoal, fundraiserRaised;
  }
  $.fn.digits = function () {
    return this.each(function () {
      $(this).text(
        $(this)
          .text()
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
      );
    });
  };
  var percent = 60;
  var time = 1200;

  var fund_raised_width = getNewWidth(fundraiserRaised, percent, fundraiserGoal);

  setPositions($(".fund_goal"), fundraiserGoal, 100, false);
  setPositions($(".fund_raised"), fundraiserRaised, fund_raised_width, false);

  setRight($(".fund_raised"), false);
  setRight($(".fund_goal"), false);

  $(".fund_goal .callout").removeClass("right").removeClass("center").addClass("left");
  setRight($(".fund_raised"), true);
  setRight($(".fund_goal"), true);

  $(".fund_raised, .fund_goal").css("width", 0).css("opacity", 1).find(".amt").text("");

  setTimeout(function () {
    // fundraiser goal
    animateNumber($(".fund_goal .amt"), fundraiserGoal, time);
    animateGoal($(".fund_goal"), 100, time);
    // team raised so far
    setTimeout(
      function () {
        animateNumber($(".fund_raised .amt"), fundraiserRaised, time);
        animateBar($(".fund_raised"), fund_raised_width, time);
      },
      (time / 4) * 1,
    );
  }, 2000);
}

function getNewWidth(val, percent, max) {
  if (val >= max) {
    return 100;
  }

  return (val / max) * 100;
}

function setPositions($div, val, width) {
  $div
    .css("width", width + "%")
    .css("opacity", 0)
    .show()
    .find(".amt")
    .text(val)
    .digits();

  $div.find("#bubble_up").css("width", $div.find(".amt").parents("div.callout").width());
}
// makes arrow right left or center
function addClasses($div1, $div2, val1, val2) {
  if (collision($div1, $div2)) {
    if (val1 < val2) {
      $div1.addClass("right");
      $div2.addClass("left");
    } else {
      $div1.addClass("left");
      $div2.addClass("right");
    }
  } else {
    $div1.addClass("center");
    $div2.addClass("center");
  }
}

function setRight($div, secondRun) {
  if ($div.length <= 0) return;

  var $callout = $div.find(".callout");

  if ($callout.hasClass("left")) {
    var barRight = $div.offset().left + $div.outerWidth(true);
    var newRight = $callout.offset().left - barRight + $callout.outerWidth(true) / 2 - 10;
    $callout.css({
      right: newRight,
    });
  } else if ($callout.hasClass("right")) {
    var barRight = $div.offset().left + $div.outerWidth(true);
    var newRight =
      $div.find(".callout").offset().left - barRight - $callout.outerWidth(true) / 2 + 20;
    $callout.css({
      right: newRight,
    });
  } else if (!secondRun) {
    var barRight = $div.offset().left + $div.outerWidth(true);
    var newRight = $callout.offset().left - barRight + $callout.outerWidth(true) / 2;
    $callout.css({
      right: newRight,
    });
  }
}

function animateNumber($input, num, time) {
  $input.animate(
    {
      text: num,
    },
    {
      easing: "swing",
      duration: time,
      step: function (fin, obj) {
        var $this = jQuery(this);
        $this.text(parseInt(fin * obj.pos));
        $this.digits();
      },
    },
  );
}

function animateBar($div, width, time) {
  $div.find(".callout").animate(
    {
      opacity: 1,
    },
    {
      easing: "swing",
      duration: time / 3,
    },
  );
  $div.animate(
    {
      width: width + "%",
    },
    {
      easing: "swing",
      duration: time,
    },
  );
}

function animateGoal($div, width, time) {
  $div.find(".callout").animate(
    {
      opacity: 1,
    },
    {
      easing: "swing",
      duration: time / 3,
    },
  );
  $div.animate(
    {
      width: width + "%",
    },
    {
      easing: "swing",
      duration: time,
    },
  );
}

function collision($div1, $div2) {
  if ($div1.length <= 0 || $div2.length <= 0) return false;

  var x1 = $div1.offset().left;
  var y1 = $div1.offset().top;
  var h1 = $div1.outerHeight(true);
  var w1 = $div1.outerWidth(true);
  var b1 = y1 + h1;
  var r1 = x1 + w1;
  var x2 = $div2.offset().left;
  var y2 = $div2.offset().top;
  var h2 = $div2.outerHeight(true);
  var w2 = $div2.outerWidth(true);
  var b2 = y2 + h2;
  var r2 = x2 + w2;

  if (b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2) return false;
  return true;
}
